<ng-template #locationNameDisplay>
  <img class="ngx-navbar__location-pin"
    src="assets/img/location-pin-icon.svg"
    alt=""
    aria-hidden="true">
  <span class="ngx-navbar__location-name"
    [attr.data-testid]="selectedLocationDisplayName + '-name'">
    {{ selectedLocationDisplayName }}
  </span>
</ng-template>

@if (locationsLoaded && !isMultiLocation) {
  <div
    class="location-switcher__mobile-value"
    data-testid="location-switcher-single">
    <ng-container *ngTemplateOutlet="locationNameDisplay"></ng-container>
  </div>
}

@if (isMultiLocation) {
  @if (shouldUseLocationSearch(locations ?? [], pageSize)) {
    <button
      type="button"
      class="location-switcher__mobile-value location-switcher__mobile-value--button"
      data-testid="select-location-dropdown-container"
      [attr.aria-expanded]="mobileInlinePickerOpen"
      (click)="toggleMobileInlinePicker()">
      <span class="location-switcher__mobile-value-content">
        <ng-container *ngTemplateOutlet="locationNameDisplay"></ng-container>
      </span>
      <mat-icon class="location-switcher__mobile-chevron"
        [class.location-switcher__mobile-chevron--open]="mobileInlinePickerOpen">
        expand_more
      </mat-icon>
    </button>
  }
  @if (!shouldUseLocationSearch(locations ?? [], pageSize)) {
    <mat-form-field
      appearance="fill"
      class="location-switcher__select-mobile"
      data-testid="select-location-dropdown-container">
      <mat-select #locationMenu
        [panelClass]="panelClass"
        [panelWidth]="panelWidth"
        [ngModel]="selectedLocation"
        [compareWith]="compareLocations"
        [disabled]="stateDisabled()"
        (selectionChange)="updateLocation($event.value)"
        (closed)="clearLocationFiltering()">
        <mat-select-trigger>
          <button type="button"
            class="location-switcher__mobile-value location-switcher__mobile-value--trigger"
            (click)="openLocationMenu($event)">
            <span class="location-switcher__mobile-value-content">
              <ng-container *ngTemplateOutlet="locationNameDisplay"></ng-container>
            </span>
            <mat-icon class="location-switcher__mobile-chevron">expand_more</mat-icon>
          </button>
        </mat-select-trigger>
        @for (loc of getDisplayLocations$() | async; track loc.locationNumber) {
          <mat-option
            [value]="loc ? loc : []"
            [attr.data-testid]="loc?.locationName + '-option'"
            [disabled]="!loc?.locationName">
            <span class="location-switcher__option-row">
              @if (loc?.locationNumber && compareLocations(loc, selectedLocation)) {
                <mat-icon
                  class="location-switcher__selected-icon"
                  aria-label="Currently selected location"
                [attr.data-testid]="loc?.locationName + '-selected-icon'">check</mat-icon>
              }
              <span class="location-switcher__option-label">{{ loc.locationName ? loc?.locationName : 'N/A' }}</span>
              @if (loc?.locationNumber) {
                <button
                  type="button"
                  class="location-switcher__favorite-star"
                  [class.location-switcher__favorite-star--active]="favoriteLocationNumbers.includes(loc.locationNumber)"
                  [attr.aria-label]="favoriteLocationNumbers.includes(loc.locationNumber) ? 'Remove from favorites' : 'Add to favorites'"
                  [attr.data-testid]="loc?.locationName + '-favorite-star'"
                  (click)="$event.stopPropagation(); toggleFavorite(loc)">
                  <mat-icon>{{ favoriteLocationNumbers.includes(loc.locationNumber) ? 'star' : 'star_border' }}</mat-icon>
                </button>
              }
            </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (shouldUseLocationSearch(locations ?? [], pageSize) && mobileInlinePickerOpen) {
    <div
      class="location-switcher__mobile-picker"
      data-testid="mobile-location-picker">
      <p class="location-switcher__mobile-picker-hint">Search by name or restaurant number</p>
      <mat-form-field appearance="fill" class="location-switcher__mobile-picker-search">
        <mat-icon matPrefix class="location-switcher__mobile-picker-search-icon">search</mat-icon>
        <input matInput
          [value]="searchTerm"
          data-testid="select-location-search-input"
          placeholder="Search Locations"
          (keyup)="onSearch($event)"
          (keydown)="$event.stopPropagation()">
      </mat-form-field>
      @if ({ filtered: getFilteredLocations$() | async, display: getDisplayLocations$() | async }; as locs) {
        <div class="location-switcher__mobile-picker-list">
          @for (loc of locs.display; track loc.locationNumber) {
            <div class="location-switcher__mobile-picker-row">
              <button type="button"
                class="location-switcher__mobile-picker-item"
                [attr.data-testid]="loc?.locationName + '-option'"
                (click)="selectMobileLocation(loc)">
                @if (loc?.locationNumber && compareLocations(loc, selectedLocation)) {
                  <mat-icon
                    class="location-switcher__selected-icon"
                    aria-label="Currently selected location"
                  [attr.data-testid]="loc?.locationName + '-selected-icon'">check</mat-icon>
                }
                <span class="location-switcher__mobile-picker-label">{{ loc.locationName }}</span>
                <mat-icon>chevron_right</mat-icon>
              </button>
              @if (loc?.locationNumber) {
                <button
                  type="button"
                  class="location-switcher__favorite-star"
                  [class.location-switcher__favorite-star--active]="favoriteLocationNumbers.includes(loc.locationNumber)"
                  [attr.aria-label]="favoriteLocationNumbers.includes(loc.locationNumber) ? 'Remove from favorites' : 'Add to favorites'"
                  [attr.data-testid]="loc?.locationName + '-favorite-star'"
                  (click)="toggleFavorite(loc)">
                  <mat-icon>{{ favoriteLocationNumbers.includes(loc.locationNumber) ? 'star' : 'star_border' }}</mat-icon>
                </button>
              }
            </div>
          }
          @if (searchTerm && locs.filtered?.length === 0) {
            <p
              class="location-switcher__mobile-picker-empty">
              There were no locations found
            </p>
          }
        </div>
        @if (locs.filtered?.length) {
          <pagination
            [totalElements]="locs.filtered.length"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            (pageRight)="pageRight()"
            (pageLeft)="pageLeft()">
          </pagination>
        }
      }
    </div>
  }
}
